export function getSafeCardLastFourDigits(...values: Array<string | null | undefined>) {
  for (const value of values) {
    const digits = String(value || "").replace(/\D/g, "");

    if (digits.length >= 4) {
      return digits.slice(-4);
    }
  }

  return "";
}
